import React from 'react';
import SkillItem from './SkillItem';

const SkillCategory = ({ icon, title, skills }) => {
  return (
    <div className="flex flex-col items-center">
      <div className="flex items-center justify-center w-16 h-16 bg-apple-gray-700 rounded-full mb-3">
        {icon}
      </div>
      <div className="text-apple-gray-700 font-medium text-lg mb-4">{title}</div>

      <div className="w-full space-y-4">
        {skills.map((skill, index) => (
          <SkillItem key={index} icon={skill.icon} text={skill.text} />
        ))}
      </div>
    </div>
  );
};

export default SkillCategory;